module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/$.iterators.js
// module id = 85
// module chunks = 1